export default __webpack_public_path__ + "static/media/61.539465c7.svg";